import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import Profile from './Pages/Profile';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Proyects from './Components/Proyects/Proyects';

function App() {
  const { i18n } = useTranslation();


  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  
  return (
    <div className='overflow-hidden no-scrollbar'>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/proyects' element={<Proyects/>} />
      </Routes>
    </div>
  );
}

export default App;
